import { memo, useEffect, useMemo } from "react";
import { SearchFilterType } from "gql/graphql";
import { useRouter } from "next-router-mock";
import { app, platform } from "@todesktop/client-core";
import useCount from "modules/hooks/use-count";

const BadgeCount = () => {
  const { count } = useCount([
    { type: SearchFilterType.IsNotSeenByMe },
    { type: SearchFilterType.IsInbox },
  ]);
  const { pathname } = useRouter();
  const isAdmin = useMemo(() => pathname.startsWith("/admin"), [pathname]);

  //Sets the browser title
  useEffect(() => {
    const faviconRef = document.getElementById("favicon");
    let title = "Synco";
    let favicon =
      process.env.NEXT_PUBLIC_ENV_NAME === "prod"
        ? "/favicon.svg"
        : "/qa_favicon.svg";
    if (isAdmin) {
      title = title.concat(" Admin");
    }
    if (count > 0) {
      title = `(${count}) `.concat(title);
      favicon =
        process.env.NEXT_PUBLIC_ENV_NAME === "prod"
          ? "/favicondot.svg"
          : "/qa_favicondot.svg";
    }
    faviconRef?.setAttribute("href", favicon);
    document.title = title;
    if (platform.todesktop.isDesktopApp()) {
      app.setBadgeCount(count);
    }
  }, [count, isAdmin]);
  return null;
};

export default memo(BadgeCount);
